import { pathmap } from './loadroots';
import { publishSync } from 'pub-sub';
// import { userstore } from '../base';
import { locationChange } from '../UserState';

export function initial_path(): void {
	const { site_path = '/' } = window.hcstatic;
	const { view } = pathmap.get(site_path)!;

	if (site_path !== '/') {
		publishSync('use-main-view');
		locationChange({ location: site_path, force: true });
	}
	view();
}
